import { getInitialStateFromConfig } from "helpers/form";

const config = {
    isEnabled: {
        // field
        label: "Включено",
        inputProps: { name: "isEnabled" },
        isCheckbox: true,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
